import {
  MyPlantsModule,
  MyPlantsState,
  MyPlantsMutationTree,
  MyPlantsActionTree,
  MyPlantsGetterTree,
} from '@/store/@types/my-plants';

import { getCareTypes, myPlants } from '@/api/plant';
import { formatCareRemiders } from '@/helper/utils';

const state: MyPlantsState = {
  careTypes: [],
  myPlants: [],
  myNewPlantsCount: 0,
  isMyPlantsFetching: false,
  isMyPlantsFetchError: false,
};

const mutations: MyPlantsMutationTree = {
  SET_CARE_TYPES(state, careTypes) {
    state.careTypes = careTypes;
  },

  SET_MY_PLANTS(state, plantsList) {
    state.myPlants = plantsList;
  },

  SET_MY_NEW_PLANTS_COUNT(state, count) {
    state.myNewPlantsCount = count;
  },

  SET_MY_PLANTS_FETCHING(state, isFetch) {
    state.isMyPlantsFetching = isFetch;
  },

  SET_MY_PLANTS_FETCH_ERROR(state, isError) {
    state.isMyPlantsFetchError = isError;
  },
};

const actions: MyPlantsActionTree = {
  async getCareTypesList({ commit }) {
    const careTypes = await getCareTypes();

    commit('SET_CARE_TYPES', careTypes);
  },

  async getMyPlants({ commit }) {
    const plantsList = await myPlants();

    commit('SET_MY_PLANTS', plantsList);
  },

  addItemToMyPlants({ state, commit }, plantObj) {
    const isPlantInList = state.myPlants.some(
      (plant) => plant.id === plantObj.id
    );

    if (isPlantInList) return;

    const newList = [...state.myPlants, plantObj];

    commit('SET_MY_PLANTS', newList);
  },

  removeItemFromMyPlants({ state, commit }, plantId) {
    const isPlantInList = state.myPlants.some((plant) => plant.id === plantId);

    if (!isPlantInList) return;

    const newList = state.myPlants.filter((plant) => {
      return plant.id !== plantId;
    });

    commit('SET_MY_PLANTS', newList);
  },

  updateItemInMyPlants({ state, commit }, plantObj) {
    const plantIdx = state.myPlants.findIndex(
      (plant) => plant.id === plantObj.id
    );

    if (plantIdx === -1) return;

    const newList = [...state.myPlants];

    newList.splice(plantIdx, 1, plantObj);

    commit('SET_MY_PLANTS', newList);
  },

  increaseMyNewPlantsCount({ state, commit }) {
    const count = state.myNewPlantsCount + 1;

    commit('SET_MY_NEW_PLANTS_COUNT', count);
  },

  decreaseMyNewPlantsCount({ state, commit }) {
    if (state.myNewPlantsCount <= 0) return;

    const count = state.myNewPlantsCount - 1;

    commit('SET_MY_NEW_PLANTS_COUNT', count);
  },

  resetMyNewPlantsCount({ commit }) {
    commit('SET_MY_NEW_PLANTS_COUNT', 0);
  },

  setMyPlantsFetching({ commit }, isFetch) {
    commit('SET_MY_PLANTS_FETCHING', isFetch);
  },

  setMyPlantsFetchError({ commit }, isError) {
    commit('SET_MY_PLANTS_FETCH_ERROR', isError);
  },
};

const getters: MyPlantsGetterTree = {
  myPlantsIds: (state) => state.myPlants.map((plant) => plant.id),

  myPlantsWithCare: (state) => {
    const formatedPlants = state.myPlants.map((plant) => {
      const formatedCares = formatCareRemiders({
        careTypes: state.careTypes,
        plantCares: plant.care,
      });

      return { ...plant, formatedCares };
    });

    return formatedPlants;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
} as MyPlantsModule;
